import { useLocation } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { userSNSState } from 'recoils/user/userState';

import { PageManager } from 'utils/security/securityUtil';

/**
 * @function useSNSLogin
 * @desc SNS 로그인 시 모달에서 사용하는 훅
 * @returns {object} 다양한 상태 관리 및 이벤트 핸들러 함수들을 반환
 */
const useSNSLogin = () => {
  const [, setUserSnsInfo] = useRecoilState(userSNSState);

  // 공통 Hooks
  const location = useLocation();

  // redirect=map-studio 처리용 헬퍼 함수
  const getSavePagePath = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectParam = searchParams.get('redirect');
    if (redirectParam) {
      return `${process.env.REACT_APP_SITE_URL}/${redirectParam}`;
    }
    return location.pathname;
  };

  /**
   * @function onKakaoLogin
   * @desc 카카오로 로그인하기 버튼 클릭 시 동작하는 함수
   */
  const onKakaoLogin = () => {
    PageManager.savePageLocal(getSavePagePath());
    setUserSnsInfo((prev) => ({ ...prev, isopen: false }));
    const kakaoLoginURL = 'https://kauth.kakao.com/oauth/authorize';
    window.location.href =
      kakaoLoginURL +
      '?client_id=' +
      process.env.REACT_APP_KAKAO_CLIENT_ID +
      '&redirect_uri=' +
      window.location.origin +
      process.env.REACT_APP_BASE_NAME +
      'auth-kakao' +
      '&response_type=code';
    // &prompt=login
  };

  /**
   * @function onNaverLogin
   * @desc 네이버로 로그인 하기 버튼 클릭 시 동작하는 함수
   */
  const onNaverLogin = () => {
    PageManager.savePageLocal(getSavePagePath());
    setUserSnsInfo((prev) => ({ ...prev, isopen: false }));
    const naverLoginURL = 'https://nid.naver.com/oauth2.0/authorize';
    window.location.href =
      naverLoginURL +
      '?client_id=' +
      process.env.REACT_APP_NAVER_CLIENT_ID +
      '&redirect_uri=' +
      window.location.origin +
      process.env.REACT_APP_BASE_NAME +
      'auth-naver' +
      '&response_type=code' +
      '&state=inavi_maps_platform';
  };

  /**
   * @function onGoogleLogin
   * @desc 구글로 로그인 하기 버튼 클릭 시 동작하는 함수
   */
  const onGoogleLogin = () => {
    PageManager.savePageLocal(getSavePagePath());
    setUserSnsInfo((prev) => ({ ...prev, isopen: false }));
    const googleLoginURL = 'https://accounts.google.com/o/oauth2/v2/auth';

    window.location.href =
      googleLoginURL +
      '?client_id=' +
      process.env.REACT_APP_GOOGLE_CLIENT_ID +
      '&redirect_uri=' +
      window.location.origin +
      process.env.REACT_APP_BASE_NAME +
      'auth-google' +
      '&response_type=code' +
      '&scope=email profile';

    // prompt=select_account
  };

  return {
    onKakaoLogin,
    onNaverLogin,
    onGoogleLogin,
  };
};

export default useSNSLogin;
